<template>
    <div class="map-overlay">
        <div class="custom-toolbar">
            <router-link
                :to="{
                    name: 'Team Settings'
                }"
            >
                <h3 class="title">Team Settings</h3>
            </router-link>
            <h3 class="title">&nbsp;&nbsp; > &nbsp;&nbsp; {{ $t('menus.setting.rateZones') }}</h3>
        </div>
        <div class="rate-zone-area-main">
            <div
                id="map_canvas"
                ref="googleMap"
                :class="[
                    isTrialExpired ? 'not-paid-map-overlay' : '',
                    longerPanelWidth ? 'shorter-google-map' : 'google-map'
                ]"
            />
            <div :class="longerPanelWidth ? 'longer-service-area-panel' : 'rate-zone-area-panel'">
                <AreasLayer
                    :map="map"
                    :drawing-manager="drawingManager"
                    :title="'Rate Zones'"
                    :id-name="'rateZoneId'"
                    :end-point-name="'/api/teams/rate-zones'"
                    :list-end-point-name="'/api/teams/rate-zones?excludeBoundaryDetails=true'"
                    :details-end-point-name="'/api/teams/rate-zones'"
                    @selectFromList="handleScreenWidth"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { mapGetters } from 'vuex';
import { MapOverviewMixin } from '@/mixins/MapOverviewMixin';

import AreasLayer from '@/components/AreasLayer';

export default {
    name: 'RateZonesOverview',
    mixins: [GeneralMixin, MapOverviewMixin],
    components: {
        AreasLayer
    },
    data() {
        return {
            map: null,
            drawingManager: null,
            longerPanelWidth: false
        };
    },
    computed: {
        ...mapGetters({
            user: 'user/user',
            isTrialExpired: 'user/isTrialExpired'
        })
    },
    methods: {
        initializeMap() {
            // get starting location of user. if there is none, default to Australia
            const { latitude, longitude } = this.user.startLocation
                ? this.user.startLocation
                : getRegionCoordinates('AU');

            const element = this.$refs.googleMap;

            this.map = this.$_map_createMap(element, latitude, longitude);
            this.drawingManager = this.$_map_drawingManager();
            this.drawingManager.setMap(this.map);
            this.drawingManager.setOptions({
                drawingControl: false
            });
        },
        handleScreenWidth(data) {
            this.longerPanelWidth = data;
        }
    },
    async mounted() {
        await this.$_map_loadGoogleMap();
        this.initializeMap();
    }
};
</script>

<style lang="scss" scoped>
// remove padding from content because it's already overridden in the DashboardLayout if the component rendered is a map (via $route.meta.isMap)

.map-overlay {
    position: relative;
    padding: 0;
    .rate-zone-area-main {
        width: 100%;
    }

    .google-map {
        width: 80% !important;
        height: 100vh !important;
        float: left;
    }
    .shorter-google-map {
        width: 60% !important;
        height: 100vh !important;
        float: left;
    }
    .rate-zone-area-panel {
        width: 20%;
        height: 100vh;
        background: #fff;
        float: right;
    }
    .longer-service-area-panel {
        width: 40%;
        height: 100vh;
        background: #fff;
        float: right;
    }

    .custom-toolbar {
        position: absolute;
        z-index: 1000;
        top: 20px;
        left: 15px;
        background: #fff;

        > div {
            padding: 5px;
        }

        .title {
            font-size: 14px;
            font-weight: 500;
            margin-top: 10px;
            padding-left: 8px;
            padding-right: 8px;
        }
    }

    .not-paid-map-overlay {
        width: 100%;
        height: calc(100vh - 60px);

        > div {
            bottom: 0;
        }
    }

    .gmnoprint-tool {
        z-index: 6;
        position: absolute;
        left: 120px;
        top: 110px;
    }
}
</style>
